import { action } from 'satcheljs/lib/legacy';
import EditorViewState from '../store/schema/EditorViewState';
import setIsDirty from './setIsDirty';

export default action('updateContent')(function updateContent(
    viewState: EditorViewState,
    content: string,
    isInitializing?: boolean
) {
    if (viewState.content != content) {
        viewState.content = content;

        if (!isInitializing) {
            // If this is the first time to update the content during intializing, don't set isDirty as true.
            setIsDirty(viewState, true /*isDirty*/);
        }
    }

    if (isInitializing) {
        viewState.initialContent = content;
    }
});
